import React, { useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectCurrentToken } from "../auth/authSlice";
import SupportFeedbackModal from "./SupportFeedbackModal";
import styles from "./SupportFeedbackButton.module.css";

const NO_FEEDBACK_BUTTON_PATHS = ["/login", "/onboarding", "/pending-approval"];

const SupportFeedbackButton = () => {
  const token = useSelector(selectCurrentToken);
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const visible = useMemo(
    () => token && !NO_FEEDBACK_BUTTON_PATHS.includes(location.pathname),
    [token, location.pathname]
  );

  if (!visible) {
    return null;
  }

  return (
    <>
      <button
        type="button"
        className={styles.button}
        onClick={() => setOpen(true)}
      >
        피드백 보내기
      </button>
      <SupportFeedbackModal open={open} onClose={() => setOpen(false)} />
    </>
  );
};

export default SupportFeedbackButton;
